"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "mandello-del-lario": {
    "abff59ec": [{
      "hkey": "220556d4",
      "slug": "mandello-del-lario",
      "name": "Mandello del Lario",
      "primary": true,
      "skipSearch": false
    }],
    "cologna": [{
      "hkey": "220556d4",
      "slug": "mandello-del-lario",
      "name": "Mandello del Lario",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "ef31d816": [{
      "hkey": "220556d4",
      "slug": "mandello-del-lario",
      "name": "Mandello del Lario",
      "primary": true,
      "skipSearch": false
    }],
    "gorlo": [{
      "hkey": "220556d4",
      "slug": "mandello-del-lario",
      "name": "Mandello del Lario",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "e8fd81c3": [{
      "hkey": "220556d4",
      "slug": "mandello-del-lario",
      "name": "Mandello del Lario",
      "primary": true,
      "skipSearch": false
    }],
    "luzzeno": [{
      "hkey": "220556d4",
      "slug": "mandello-del-lario",
      "name": "Mandello del Lario",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "3b4e83ab": [{
      "hkey": "e6a00816",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "mandello-a-lago": [{
      "hkey": "e6a00816",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "7c5924b9": [{
      "hkey": "220556d4",
      "slug": "mandello-del-lario",
      "name": "Mandello del Lario",
      "primary": true,
      "skipSearch": false
    }],
    "molina": [{
      "hkey": "220556d4",
      "slug": "mandello-del-lario",
      "name": "Mandello del Lario",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "bdd1fe60": [{
      "hkey": "220556d4",
      "slug": "mandello-del-lario",
      "name": "Mandello del Lario",
      "primary": true,
      "skipSearch": false
    }],
    "sonvico": [{
      "hkey": "220556d4",
      "slug": "mandello-del-lario",
      "name": "Mandello del Lario",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "75a55656": [{
      "hkey": "220556d4",
      "slug": "mandello-del-lario",
      "name": "Mandello del Lario",
      "primary": true,
      "skipSearch": false
    }],
    "tonzanico": [{
      "hkey": "220556d4",
      "slug": "mandello-del-lario",
      "name": "Mandello del Lario",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;